import SpeciesContext from '@/context/SpeciesContext';
import { useSpeciesOnlyForContext } from '@/hooks/species/useSpeciesOnlyForContext';

export const SpeciesProvider = ({
	children,
}: {
	children: React.ReactNode;
}) => {
	const useSpeciesOutcome = useSpeciesOnlyForContext();

	return (
		<SpeciesContext.Provider value={useSpeciesOutcome}>
			{children}
		</SpeciesContext.Provider>
	);
};
